/**
 * combineReducers.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */
import { connectRouter } from "connected-react-router";
import storage from "redux-persist/lib/storage"; //
import userConstants from "../constants/userConstants";
import authentication, { IAuthenticationReducer } from "./authenticationReducer";
import alert, { IAlertReducer } from "./alertReducer";
import preferences, { IPreferencesReducer } from "./preferencesReducer";
import micStatus, { IMicReducer } from "./micReducer";
import callHistory, { ICallHistoryReducer } from "./callHistoryReducer";
import voicemails, { IVoicemailsReducer } from "./voicemailsReducer";
import callReducer, { ICallReducer } from "./callReducer";
import conversations, { IConversationsReducer } from "./conversationReducer";
import textMessageDraft, { ITextMessageDraftReducer } from "./textMessageDraftReducer";
import webRTCConnection, { IWebRTCConnectionReducer } from "./webRTCConnectionReducer"; //
import itemSelection, { IItemSelectionReducer } from "./ItemSelectionReducer";
import moxtraReducer, { IMoxtraReducer } from "./moxtraReducer";
import appReducer, { IAppReducer } from "./appReducer";
import contactsReducer, { IContactsReducer } from "./contactsReducer";
import impersonateUserReducer from "./impersonateUserReducer";
import textMessageHistoryReducer from "./textMessageHistoryReducer";
import { combineReducers } from "@reduxjs/toolkit";
import kingcobraApi from "@services/kingcobraApi";
/**
 * Combine all reducers into one root class for external use
 */
export const createAppReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    authentication,
    alert,
    appReducer,
    preferences,
    callHistory,
    micStatus,
    voicemails,
    callReducer,
    conversations,
    contactsReducer,
    impersonateUserReducer,
    textMessageHistoryReducer,
    textMessageDraft,
    webRTCConnection,
    itemSelection,
    moxtra: moxtraReducer,
    [kingcobraApi.reducerPath]: kingcobraApi.reducer
  });

export default function createRootReducer(history) {
  const appReducer = createAppReducer(history);
  return (state, action) => {
    let newState = state;
    if (action.type === userConstants.LOGOUT) {
      // Remove all store data in localstorage
      storage.removeItem("persist:rootStore");

      newState = undefined;
    } else if (action.type === userConstants.RESET_STORE_EXCEPT_IMPERSONATE_USER_ID) {
      const { impersonateUserReducer } = state;
      newState = { impersonateUserReducer };
    }
    return appReducer(newState, action);
  };
}
